import React from "react";

// Subtle city skyline behind the header (set inline — public assets can't be url() in CSS)
const FL5_BG =
  "linear-gradient(180deg,rgba(11,21,51,.55),rgba(11,21,51,.90) 34%,#0B1533 54%),url('/brand/every_building.jpg')";

const LAYERS = [
  {
    n: "01",
    img: "/brand/fl5_building.jpg",
    title: "Energy Intelligence",
    sub: "IoT + AI · The Intelligence Layer",
    body: "See and eliminate waste before you invest a penny. Knowledge Before Investment.",
    badge: "15–25%", badgeSub: "Savings",
  },
  {
    n: "02",
    img: "/brand/solar/s4.jpg",
    title: "Solar PV",
    sub: "Design & Install · Generation Layer",
    body: "Generate your own clean electricity on-site and slash grid dependency.",
    badge: "up to 70%", badgeSub: "Savings",
  },
  {
    n: "03",
    img: "/brand/battery/b5.jpg",
    title: "Battery Storage",
    sub: "Store · Buy & Sell Layer",
    body: "Store excess energy and trade it — buying and selling at the cheapest rates.",
    badge: "+20%", badgeSub: "Savings",
  },
  {
    n: "04",
    img: "/brand/fl5_synchronise.jpg",
    title: "Synchronise",
    sub: "Everything Working As One",
    body: "Intelligence, generation and storage perfectly coordinated in real time.",
    badge: "Optimised",
  },
  {
    n: "05",
    img: "/brand/fl5_cii.jpg",
    title: "CII",
    sub: "Central Distribution & Command",
    body: "One command point for complete multi-site management, control and reporting.",
    badge: "Multi-Site",
  },
];

export default function FiveLayers() {
  return (
    <div className="fl5" data-testid="five-layers"
      style={{ backgroundImage: FL5_BG, backgroundSize: "cover", backgroundPosition: "top center" }}>
      <div className="fl5-eyebrow">Products · Savings</div>
      <h2 className="fl5-title">Five Layers to <span className="g">Energy Independence.</span></h2>
      <p className="fl5-lead">Each layer builds on the last — starting with knowledge, ending with complete control across every site.</p>
      <div className="fl5-kbi">Knowledge Before Investment</div>

      <div className="fl5-rows">
        {LAYERS.map((l) => (
          <div className="fl5-row" key={l.n} data-testid={`layer-${l.n}`}>
            <div className="fl5-thumb" style={{ backgroundImage: `url('${l.img}')` }}>
              <span className="fl5-num">{l.n}</span>
            </div>
            <div className="fl5-main">
              <h3>{l.title}</h3>
              <div className="fl5-sub">{l.sub}</div>
              <p>{l.body}</p>
            </div>
            <div className="fl5-badge">
              <span className="fl5-pc">{l.badge}</span>
              {l.badgeSub && <span className="fl5-lbl">{l.badgeSub}</span>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
